export const Minus = () => (
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    className="u-icon u-icon--utility-minus"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.73814 7.00123C4.24604 6.98157 4 7.19782 4 7.65C4 8.10218 4.24604 8.31843 4.73814 8.29877C6.65927 8.29877 9.98021 8.29877 12.2619 8.29877C12.637 8.29877 13 8.10218 13 7.65C13 7.19782 12.637 6.99978 12.2619 7.00123C10.6444 7.00748 5.99508 7.01963 4.73814 7.00123Z"
      fill="currentColor"
    />
  </svg>
);
